module.exports = __webpack_public_path__ + "img/8.c529e0fb.png";